/* eslint-disable */
import { produce } from "immer";
import {
  HOME_ALERT_FETCH_FAILURE,
  HOME_ALERT_FETCH_SUCCESS,
  HOME_ALERT_FETCH_START,
} from "../actions/types";

const homeAlert = (
  state = {
    alertFetching: false,
    alertData: [],
    alertError: null,
  },
  action,
) => {
  switch (action.type) {
    case HOME_ALERT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case HOME_ALERT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case HOME_ALERT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default homeAlert;
